import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useLogout } from 'js/hooks/auth';
import { useTranslations } from 'js/hooks/i18n';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { setIgnoreLogoutNotification } from 'js/components/system/App/store/actions';
import { useConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';
import { showLogoutNotificationPopupAction } from 'js/components/popups/LogoutNotificationPopup';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useAppSelector } from 'js/store/hooks';
import { prop } from 'ramda';

export const useLegacyLogoutHandler = () => {
    const showConfirmationPopup = useConfirmationPopup();
    const isLoginAgainPopup = useAppSelector(prop('isLoginAgainPopup'));
    const translate = useTranslations('playtech.mobile.system.');
    const logout = useLogout();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();

    useEffect(() => {
        const invokeLogoutConfirmation = () => {
            showConfirmationPopup({
                content: translate('logoutconfirm.title'),
                acceptBtnText: translate('logout.button.title'),
                declineBtnText: translate('cancel.button.title'),
                onAccept: async () => {
                    dispatch(setIgnoreLogoutNotification(true));

                    await logout({ isManual: true });

                    closePopups('logout');

                    dispatch(showLogoutNotificationPopupAction({
                        isLoginAgainPopup,
                        onAccept: () => showLoginPopup()
                    }));

                    dispatch(setIgnoreLogoutNotification(false));
                },
                isModal: false,
                className: 'logout-confirm-popup'
            });
        };

        dispatcher.listen('auth:action:logout', invokeLogoutConfirmation);

        return () => {
            dispatcher.removeListener('auth:action:logout', invokeLogoutConfirmation);
        };
    }, [
        dispatch,
        closePopups,
        isLoginAgainPopup,
        showLoginPopup,
        translate,
        logout,
        showConfirmationPopup
    ]);
};
